import gallery1Img from "../assets/images/gallery-images/Impact_story_photo_FOR M(om).jpeg";
import gallery6Img from "../assets/images/gallery-images/story-gallery-img6.jpg";
import S3CLink from "../components/S3CLink";

const galleryList = [
  {
    id: 0,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: FOR M(om) staff providing health care to the community </span> 
        <strong className='gallery-coalition-title'>The Power of Community Engagement</strong>
        Before FOR M(om)'s community engagement, two pregnant women in a rural community in Lagos State, lacked essential health care knowledge and access. It was through FOR M(om) that the women were able to attend informative sessions and receive prenatal care at Manifel Hospital. The two women went on to have healthy pregnancies and safe childbirths. FOR M(om)'s impact transformed their journey and countless others, illustrating the tangible benefits of community engagement in maternal and child health.
      </p>
    ),
    image: gallery1Img
  },
  {
    id: 1,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: FOR M(om)’s community engagement efforts </span> 
        <strong className='gallery-coalition-title'>Empowering Women through Community Engagement</strong>
        Before FOR M(om)'s community engagement efforts, women lacked essential health care knowledge and access in the rural community of Ikotun, Lagos State. Two pregnant women reported benefitting from information sessions and prenatal care at their local hospital. They went on to have healthy pregnancies, safe childbirths, and they each have thriving newborns now. FOR M(om)'s impact transformed their experiences and countless others, illustrating the tangible benefits of community engagement in maternal and child health.   
      </p>
    ),
    image: gallery6Img
  }
];

export default galleryList;
